'use client';

import React, {useState} from 'react';
import {useTranslations} from 'next-intl';
import Dropdown, {type DropdownMenuItem} from './Dropdown';
import {useUser} from 'src/utils/auth/userAtoms';
import {clearData} from 'src/services/storage';
import {overviewLine} from 'src/utils/icons';
import BaseButton from './BaseButton';
import Avatar from './Avatar';

type Props = {initialUser?: User};

const UserMenu = ({initialUser}: Props) => {
  const {user} = useUser(initialUser);
  const [isOpen, setOpen] = useState(false);
  const t = useTranslations();

  if (!user) return null;

  const onLogOut = () => {
    clearData();

    // Full refresh is used here to reset analytics
    window.location.href = '/';
  };

  const items: DropdownMenuItem[] = [
    {text: t('common.home'), href: '/dashboard', icon: overviewLine},
    user.isAdmin || user.isCoach
      ? {text: t('common.admin', {count: 1}), href: '/admin/dashboard', iconName: 'vip-crown-line'}
      : undefined,
    user.isSales
      ? {text: t('common.admin', {count: 1}), href: '/admin/clients', iconName: 'vip-crown-line'}
      : undefined,
    {text: t('common.profile'), href: '/profile', iconName: 'user-line'},

    {
      text: t('common.help'),
      href: 'mailto:coach@panelista.com',
      iconName: 'question-line'
    },
    {text: t('common.log out'), onClick: onLogOut, iconName: 'logout-box-r-line'}
  ].filter(Boolean);

  return (
    <Dropdown items={items} align="end" className="min-w-[150px]">
      <BaseButton className="rounded-full w-9 p-1" onClick={() => setOpen(!isOpen)}>
        <Avatar user={user} className="w-[34px] h-[34px]" />
      </BaseButton>
    </Dropdown>
  );
};

export default UserMenu;
